export const CHECKPIN_ERROR = '@checkpin/CHECKPIN_ERROR';
export type CHECKPIN = typeof CHECKPIN_ERROR;

export interface SetErrorPin {
  type: CHECKPIN;
  payload: {
    errorPin: null,
  }
}

export function setErrorPin(errorPin: any): SetErrorPin {
  return {
    type: CHECKPIN_ERROR,
    payload: {
      errorPin: errorPin
    }
  };
}